export default __webpack_public_path__ + "static/media/icon_warning.9a765e64b4b661b8b2c9b83e05bffe36.svg";